import(/* webpackMode: "eager" */ "/vercel/path0/app/tokenomics/page.tsx");
